import { startCase } from "lodash";

/**
 * Flatterns value that is either an array or a flat comma separated list into a flat comma separated list.
 * @param value
 * @returns comma separated list (with space)
 */
export function flattenCommaSeparatedList(value: string|string[]): string {
    const str = Array.isArray(value)
        ? value.map((v) => v.trim()).filter((v) => v != '').join(', ')
        : value;
    return str;
}

export function commaSeparatedListToArray(value: string): string[] {
    return value.split(',').map((v) => v.trim()).filter((v) => v != '');
}